<div class="patron-graph-side-panel">
  <app-tab-view
    [tabs]="tabs"
    [activeTabId]="activeTabId"
    [tabStyle]="'default'"
    [tabPosition]="'top'"
    (tabChange)="onTabChange($event)"
    [@panelState]="mode"
  >
    <!-- Tab content will be projected here -->
    <div *ngIf="activeTabId === 'backgroundStatus'" class="tab-content">
      <app-json-renderer [data]="candidateDetails" [level]="0" [parentKey]="'Candidate Details'"></app-json-renderer>
    </div>

    <div *ngIf="activeTabId === 'apiResponse'" class="tab-content">
      <app-json-renderer
        *ngIf="apiResponse"
        [data]="apiResponse"
        [level]="0"
        [parentKey]="'API Response'"
      ></app-json-renderer>
      <div *ngIf="!apiResponse" class="text-center">No API response available</div>
    </div>

  </app-tab-view>

  <div class="toolbar">
    <app-svg-icons [iconName]="'sidebar'" (click)="onSidebarModeToggle()"></app-svg-icons>
    <app-svg-icons [iconName]="'maximize'" (click)="onMaximizeToggle()"></app-svg-icons>
  </div>
</div>
